import { render, staticRenderFns } from "./ProductAccordion.vue?vue&type=template&id=d9bfd198&"
import script from "./ProductAccordion.vue?vue&type=script&lang=js&"
export * from "./ProductAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports